
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as signupB4YSZRkNKB9FDeS0v8yAB_45DoR_piC_5XlQOStR63J_45MMeta } from "/vercel/path0/pages/signup.vue?macro=true";
import { default as indexu6VUi26XJSPeygrbo1TLgQRYPQYEXunCoL_45tmff89dMMeta } from "/vercel/path0/pages/contacts/index.vue?macro=true";
import { default as contactsGlPsXOYtjZxL2wpMVHpUc0wnHYJZPKr_XGyMnGh1f7kMeta } from "/vercel/path0/pages/contacts.vue?macro=true";
import { default as dashboardKgoay9VAK7CxGVzaZM9Nk6S4QXOmNGok_45ZJZY_Gdk3QMeta } from "/vercel/path0/pages/dashboard.vue?macro=true";
import { default as indexFQKJnHlB25K87EFZVJWeA2ZYhVetQCgEq9JrTGVTke0Meta } from "/vercel/path0/pages/auth/index.vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as usersvx48kDSCeo17paUbieU_cw6gbzgYrs_45V7tQ0rQgD9fQMeta } from "/vercel/path0/pages/admin/users.vue?macro=true";
import { default as email_45editorfrTIUueRJT7luogliowU69f4pYae8dTFArRMQQQOiOUMeta } from "/vercel/path0/pages/email-editor.vue?macro=true";
import { default as unauthorizedK0eKq87Ipcr1dfJimqi2XLyXRh97Jx31XMqzIc4bbQcMeta } from "/vercel/path0/pages/unauthorized.vue?macro=true";
import { default as callbackh5BlNk_5NmpfVDD4b6dX2d7K12NPXA5wsmB_CKYJNNsMeta } from "/vercel/path0/pages/auth/callback.vue?macro=true";
import { default as neweTiF6DkQCUWncuV2BHtkUd8mW0tTfmvoN9plhgDsZ_45wMeta } from "/vercel/path0/pages/templates/new.vue?macro=true";
import { default as indexv1fFzc2ShcljiGo28Bo2KD8xzvwNrH7uZVZ3jm__I8gMeta } from "/vercel/path0/pages/settings/index.vue?macro=true";
import { default as index5UuwoNe49AzgmIWNKfU65XgCUjxrpfQSTXUVx6_4558VcMeta } from "/vercel/path0/pages/analytics/index.vue?macro=true";
import { default as indexA3gAnHil6NAbO9fQFT05eCXtOspgdDuHHS7lEwCry_45IMeta } from "/vercel/path0/pages/campaigns/index.vue?macro=true";
import { default as domain0ABVTDlUVusogSy4rKcOnQqW3ngHfpy8o7HIc0gwukkMeta } from "/vercel/path0/pages/settings/domain.vue?macro=true";
import { default as index_45SxPpf9CL7T2yY3RiaZ0pGGqQraQq4KVzxft0sdwROQMeta } from "/vercel/path0/pages/templates/index.vue?macro=true";
import { default as amazon_45sesqQYMwJr_dhX_QBZQzhN_5IKGnorWAShA8SqTo6Wwq8sMeta } from "/vercel/path0/pages/test/amazon-ses.vue?macro=true";
import { default as createDoQncPGFfPeMeNt9RAc652UNwkR9kURhT_n_45ETHYAjYMeta } from "/vercel/path0/pages/campaigns/create.vue?macro=true";
import { default as profilei5CW5yLQYH5pidw_yW588_45d5iZY01eRFb1FNwPKJKkcMeta } from "/vercel/path0/pages/settings/profile.vue?macro=true";
import { default as reset_45password6LLtCEAcDAc7CNK0fd8tOMdP9INZZZLl1DhKX_Z5qEQMeta } from "/vercel/path0/pages/auth/reset-password.vue?macro=true";
import { default as editJ0frveANt10JlEZwCgWT7y7wKnfFHZYaYuBdgDAOl6QMeta } from "/vercel/path0/pages/campaigns/[id]/edit.vue?macro=true";
import { default as editD3QJev_4544_45WKyWxj817duLLOmSm_4t5NvRMGZPlFtKoMeta } from "/vercel/path0/pages/templates/[id]/edit.vue?macro=true";
import { default as forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta } from "/vercel/path0/pages/auth/forgot-password.vue?macro=true";
import { default as indexiMiPzp93DY_6W84uzBQOukyIP1Sedhh_45DoxGFGyQ34oMeta } from "/vercel/path0/pages/campaigns/[id]/index.vue?macro=true";
import { default as index65L5zAMf0Ma2oZ9_JbzTxn5WsoqvxUzfvKMJzmfewp0Meta } from "/vercel/path0/pages/admin/campaigns/index.vue?macro=true";
import { default as subscriptionrjDEnry3QgJ4L2k7qapPl0QwUXeVJf_45bC6HpGW87_LAMeta } from "/vercel/path0/pages/settings/subscription.vue?macro=true";
import { default as indexowR9_45GefzP9Eo94WmW7RuMDt9PSHwScjJuVMMFnu_45OgMeta } from "/vercel/path0/pages/campaigns/wizard/index.vue?macro=true";
import { default as builderpEOPXBNQO6l0MbteBrjyMOOscR6a12EzDKi9NS0rAksMeta } from "/vercel/path0/pages/admin/campaigns/builder.vue?macro=true";
import { default as domain3Iob9K4CO0geGuqzdmC47klPqmEiVC4XE8h5lUqQLAwMeta } from "/vercel/path0/pages/campaigns/wizard/domain.vue?macro=true";
import { default as reviewaw_n3kPExSb3uoASIQ9jYvlOTkt2hmCqMBLo9ez8lRMMeta } from "/vercel/path0/pages/campaigns/wizard/review.vue?macro=true";
import { default as sendery7zCSTUrSW2LfsWXC4GaPhLAIXNarsMlnaTxLUHJlfgMeta } from "/vercel/path0/pages/campaigns/wizard/sender.vue?macro=true";
import { default as contactseCofIQB1JGOAb0ZX8tjUITq_45FzdLOB9Rkhxj0HD_YFUMeta } from "/vercel/path0/pages/campaigns/wizard/contacts.vue?macro=true";
import { default as schedulenuHXrBdez_45j5MPYyYV56dz802Snn0bKzMNB8tapaL3YMeta } from "/vercel/path0/pages/campaigns/wizard/schedule.vue?macro=true";
import { default as template_45ybuvXYFldGp5maVpz_kbMTn3dF4OA_vvPlEtaCVZoAMeta } from "/vercel/path0/pages/campaigns/wizard/template.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupB4YSZRkNKB9FDeS0v8yAB_45DoR_piC_5XlQOStR63J_45MMeta || {},
    component: () => import("/vercel/path0/pages/signup.vue")
  },
  {
    name: contactsGlPsXOYtjZxL2wpMVHpUc0wnHYJZPKr_XGyMnGh1f7kMeta?.name,
    path: "/contacts",
    component: () => import("/vercel/path0/pages/contacts.vue"),
    children: [
  {
    name: "contacts",
    path: "",
    meta: indexu6VUi26XJSPeygrbo1TLgQRYPQYEXunCoL_45tmff89dMMeta || {},
    component: () => import("/vercel/path0/pages/contacts/index.vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardKgoay9VAK7CxGVzaZM9Nk6S4QXOmNGok_45ZJZY_Gdk3QMeta || {},
    component: () => import("/vercel/path0/pages/dashboard.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/vercel/path0/pages/auth/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {},
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: usersvx48kDSCeo17paUbieU_cw6gbzgYrs_45V7tQ0rQgD9fQMeta || {},
    component: () => import("/vercel/path0/pages/admin/users.vue")
  },
  {
    name: "email-editor",
    path: "/email-editor",
    component: () => import("/vercel/path0/pages/email-editor.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    meta: unauthorizedK0eKq87Ipcr1dfJimqi2XLyXRh97Jx31XMqzIc4bbQcMeta || {},
    component: () => import("/vercel/path0/pages/unauthorized.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callbackh5BlNk_5NmpfVDD4b6dX2d7K12NPXA5wsmB_CKYJNNsMeta || {},
    component: () => import("/vercel/path0/pages/auth/callback.vue")
  },
  {
    name: "templates-new",
    path: "/templates/new",
    meta: neweTiF6DkQCUWncuV2BHtkUd8mW0tTfmvoN9plhgDsZ_45wMeta || {},
    component: () => import("/vercel/path0/pages/templates/new.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexv1fFzc2ShcljiGo28Bo2KD8xzvwNrH7uZVZ3jm__I8gMeta || {},
    component: () => import("/vercel/path0/pages/settings/index.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: index5UuwoNe49AzgmIWNKfU65XgCUjxrpfQSTXUVx6_4558VcMeta || {},
    component: () => import("/vercel/path0/pages/analytics/index.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    meta: indexA3gAnHil6NAbO9fQFT05eCXtOspgdDuHHS7lEwCry_45IMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/index.vue")
  },
  {
    name: "settings-domain",
    path: "/settings/domain",
    meta: domain0ABVTDlUVusogSy4rKcOnQqW3ngHfpy8o7HIc0gwukkMeta || {},
    component: () => import("/vercel/path0/pages/settings/domain.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: index_45SxPpf9CL7T2yY3RiaZ0pGGqQraQq4KVzxft0sdwROQMeta || {},
    component: () => import("/vercel/path0/pages/templates/index.vue")
  },
  {
    name: "test-amazon-ses",
    path: "/test/amazon-ses",
    component: () => import("/vercel/path0/pages/test/amazon-ses.vue")
  },
  {
    name: "campaigns-create",
    path: "/campaigns/create",
    meta: createDoQncPGFfPeMeNt9RAc652UNwkR9kURhT_n_45ETHYAjYMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/create.vue")
  },
  {
    name: "settings-profile",
    path: "/settings/profile",
    meta: profilei5CW5yLQYH5pidw_yW588_45d5iZY01eRFb1FNwPKJKkcMeta || {},
    component: () => import("/vercel/path0/pages/settings/profile.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45password6LLtCEAcDAc7CNK0fd8tOMdP9INZZZLl1DhKX_Z5qEQMeta || {},
    component: () => import("/vercel/path0/pages/auth/reset-password.vue")
  },
  {
    name: "campaigns-id-edit",
    path: "/campaigns/:id()/edit",
    meta: editJ0frveANt10JlEZwCgWT7y7wKnfFHZYaYuBdgDAOl6QMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/[id]/edit.vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    meta: editD3QJev_4544_45WKyWxj817duLLOmSm_4t5NvRMGZPlFtKoMeta || {},
    component: () => import("/vercel/path0/pages/templates/[id]/edit.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta || {},
    component: () => import("/vercel/path0/pages/auth/forgot-password.vue")
  },
  {
    name: "campaigns-id",
    path: "/campaigns/:id()",
    meta: indexiMiPzp93DY_6W84uzBQOukyIP1Sedhh_45DoxGFGyQ34oMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/[id]/index.vue")
  },
  {
    name: "admin-campaigns",
    path: "/admin/campaigns",
    meta: index65L5zAMf0Ma2oZ9_JbzTxn5WsoqvxUzfvKMJzmfewp0Meta || {},
    component: () => import("/vercel/path0/pages/admin/campaigns/index.vue")
  },
  {
    name: "settings-subscription",
    path: "/settings/subscription",
    meta: subscriptionrjDEnry3QgJ4L2k7qapPl0QwUXeVJf_45bC6HpGW87_LAMeta || {},
    component: () => import("/vercel/path0/pages/settings/subscription.vue")
  },
  {
    name: "campaigns-wizard",
    path: "/campaigns/wizard",
    meta: indexowR9_45GefzP9Eo94WmW7RuMDt9PSHwScjJuVMMFnu_45OgMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/index.vue")
  },
  {
    name: "admin-campaigns-builder",
    path: "/admin/campaigns/builder",
    meta: builderpEOPXBNQO6l0MbteBrjyMOOscR6a12EzDKi9NS0rAksMeta || {},
    component: () => import("/vercel/path0/pages/admin/campaigns/builder.vue")
  },
  {
    name: "campaigns-wizard-domain",
    path: "/campaigns/wizard/domain",
    meta: domain3Iob9K4CO0geGuqzdmC47klPqmEiVC4XE8h5lUqQLAwMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/domain.vue")
  },
  {
    name: "campaigns-wizard-review",
    path: "/campaigns/wizard/review",
    meta: reviewaw_n3kPExSb3uoASIQ9jYvlOTkt2hmCqMBLo9ez8lRMMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/review.vue")
  },
  {
    name: "campaigns-wizard-sender",
    path: "/campaigns/wizard/sender",
    meta: sendery7zCSTUrSW2LfsWXC4GaPhLAIXNarsMlnaTxLUHJlfgMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/sender.vue")
  },
  {
    name: "campaigns-wizard-contacts",
    path: "/campaigns/wizard/contacts",
    meta: contactseCofIQB1JGOAb0ZX8tjUITq_45FzdLOB9Rkhxj0HD_YFUMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/contacts.vue")
  },
  {
    name: "campaigns-wizard-schedule",
    path: "/campaigns/wizard/schedule",
    meta: schedulenuHXrBdez_45j5MPYyYV56dz802Snn0bKzMNB8tapaL3YMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/schedule.vue")
  },
  {
    name: "campaigns-wizard-template",
    path: "/campaigns/wizard/template",
    meta: template_45ybuvXYFldGp5maVpz_kbMTn3dF4OA_vvPlEtaCVZoAMeta || {},
    component: () => import("/vercel/path0/pages/campaigns/wizard/template.vue")
  }
]